import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { categories } from '../Data/data';
import { Row, Col, Button } from 'reactstrap';
import DocumentTitle from '../Components/DocumentTitle';
import { BsWhatsapp } from "react-icons/bs";

const Detail = () => {
    const { slug } = useParams();
    let findCategory = categories.find(category => category.slug == slug);
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='container'>
            <DocumentTitle title={`Home | ${findCategory.heading}`} />
            <Row className='my-5'>
                <Col xs='12' sm='12' md='6' lg='6'>
                    <img src={findCategory.img} className='img-thumbnail img-fluid' alt="" />
                </Col>
                <Col xs='12' sm='12' md='6' lg='6'>
                    <div className='text-center'>
                        <h1>{findCategory.heading}</h1>
                        <p>{findCategory.description}</p>
                        <a target='_blank' href='https://wa.me/971501790123' className='btn' style={{ background: '#25D366', color: 'white', border: '0' }}><BsWhatsapp /> Contact us</a>
                    </div>
                </Col>
            </Row>
        </div>
    )
};

export default Detail;